import React, { FC, ReactNode } from 'react';
import useModalRouter from '../../common/hooks/useModalRouter';
import ModalWrapper from '../../components/modals/ModalWrapper';
import { IModal } from '../../router/ModalRouter';
import DefaultMobileAppSignupBonusModal from '../../../../modals/mobile-app-signup-bonus/MobileAppSignupBonusModal';
import { IonContent } from '@ionic/react';
import { MobileAppSignupBonusModalProps } from '../../../../services/exports/Interfaces';
import ModalHeader from '../../components/modals/ModalHeader';
import useInitialData from '../../../../hooks/global/useInitialData';
import { useTranslation } from 'react-i18next';
import MobileIcon from '../../../../assets/icons/MobileIcon';

const MobileAppSignupBonusModal: FC<Partial<IModal> & MobileAppSignupBonusModalProps> = (props): ReactNode => {
  const { closeModal } = useModalRouter();

  return (
    <ModalWrapper>
      <IonContent className="min-h-[90dvh]">
        <ModalHeader title={<Header />} onClose={closeModal} />
        <DefaultMobileAppSignupBonusModal {...props} />
      </IonContent>
    </ModalWrapper>
  );
};

const Header = () => {
  const { data } = useInitialData();
  const { t } = useTranslation(undefined, { keyPrefix: 'Modals:MobileAppSignupBonusModal' });

  return (
    <div className="flex items-center text-center w-fit mx-auto">
      <MobileIcon className="text-orange-400 mr-sm" />
      <h3 className="text-md">{t('title', { app: data?.franchise.name })}</h3>
    </div>
  );
};

export default MobileAppSignupBonusModal;
